<template>
  <div v-if="loadingStore.isLoading" class="modern-spinner-overlay">
    <div class="spinner">
      <div class="circle"></div>
      <span class="loading-text">Yükleniyor...</span>
    </div>
  </div>

  <component :is="layoutComponent" />
</template>
<script setup>
import { useLoadingStore } from "@/stores/loadingStore";
import LandingLayout from "@/components/LandingLayout.vue";
import AuthLayout from "@/components/AuthLayout.vue";
import DashboardLayout from "@/components/DashboardLayout.vue";
import { computed, onMounted } from "vue";

import { useRoute } from "vue-router";
import { CommonDefinitions } from "@/auxiliary/List";
import { getCities } from "@/services/userServices";

const route = useRoute();

// Dinamik olarak layout'u belirleme Router icindeki meta layout dan 3 ana layoutdan biri otamatik olarak routelara verilebiliyor.
const layoutComponent = computed(() => {
  switch (route.meta.layout) {
    case "auth":
      return AuthLayout;
    case "landing":
      return LandingLayout;
    case "dashboard":
      return DashboardLayout;
    default:
      return LandingLayout;
  }
});

const loadingStore = useLoadingStore();

onMounted(async () => {
  CommonDefinitions.Cities = await getCities();
});
</script>
<style scoped>
.modern-spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(
    113,
    158,
    255
  ); /* Daha koyu yarı saydam bir arka plan */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.circle {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 1s infinite linear;
}

.loading-text {
  margin-top: 15px;
  font-size: 16px;
  color: #ffffff;
  font-weight: 500;
  opacity: 0.9;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Dönme animasyonu */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
